var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"snoop-button",class:[
        ("snoop-button--" + _vm.theme),
        { 'snoop-button--disabled': _vm.disabled } ],attrs:{"disabled":_vm.disabled}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }